import { useEffect, useRef, useState } from "react";
import type { Project } from "../lib/types";

interface Props {
  projects: Project[];
  defaultProjectId: string | null;
  onSave: (title: string, brainDump: string, projectId: string | null) => void;
  onClose: () => void;
}

export function NewIdeaSheet({ projects, defaultProjectId, onSave, onClose }: Props) {
  const [title, setTitle] = useState("");
  const [brainDump, setBrainDump] = useState("");
  const [projectId, setProjectId] = useState<string | null>(defaultProjectId);
  const titleRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;
    onSave(title.trim(), brainDump.trim(), projectId);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-40 flex flex-col justify-end" onClick={onClose}>
      <div
        className="bg-white rounded-t-2xl shadow-2xl p-5 pb-8 max-w-[480px] w-full mx-auto animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-5" />
        <h2 className="font-syne text-lg font-bold mb-4">New idea</h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            ref={titleRef}
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title"
            className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-gray-800"
            required
          />
          <textarea
            value={brainDump}
            onChange={(e) => setBrainDump(e.target.value)}
            placeholder="Brain dump (optional)"
            rows={4}
            className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-gray-800 resize-none"
          />
          <select
            value={projectId ?? ""}
            onChange={(e) => setProjectId(e.target.value || null)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-gray-800 bg-white"
          >
            <option value="">Inbox</option>
            {projects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
          <button
            type="submit"
            className="w-full bg-gray-900 text-white rounded-lg py-2.5 text-sm font-mono font-bold hover:bg-gray-700 transition-colors mt-1"
          >
            Create
          </button>
        </form>
      </div>
    </div>
  );
}
